import { getProductFormField } from '../utils';
import Component from './ProductFormCheckbox';
import { injectIntl } from 'react-intl';

export default getProductFormField(injectIntl(Component));
